<div class="page">

    <section class="section-account parallax bg-11" style="background-image:url(assets/images/header-1.jpg)">
        <div class="awe-overlay"></div>
        <div class="container">
            <div class="login-register">
                <div>
                    <form class="account_form">
                        <h2 class="text text-center">FORGOT PASSWORD</h2>
                        <fieldset>
                            <legend>

                                <label>Email:
                                    <small style="color:red">*</small>
                                </label>
                                <input type="text" [(ngModel)]="email" name="email" class="field-text" placeholder="Enter Your Email Address">
                                <span style="color: red;font-size: 12px;" *ngIf="errorMessage">
                                    {{errorMessage}}
                                </span>
                                <div class="field-form field-submit">
                                    <button (click)="resetPassword(email)" [disabled]="!email" class="awe-btn awe-btn-13">Email me to reset my password</button>
                                </div>
                            </legend>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </section>

</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/forgot-password/forgot-password.component.html